"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("page", {
    attrs: {
      "return-menu": "/farm-management/dashboard",
      menu: _vm.page.children,
      subtitle: _vm.page.meta.title
    },
    scopedSlots: _vm._u([{
      key: "context",
      fn: function fn() {
        return [_c("section", {
          staticClass: "lots-page"
        }, [_c("header", {
          staticClass: "page-header"
        }, [_c("h1", {
          staticClass: "page-title"
        }, [_vm._v("\n          Lotes\n        ")]), _vm._v(" "), _c("b-button", {
          staticClass: "btn plant-nursery-primary-btn",
          attrs: {
            type: "is-primary"
          },
          on: {
            click: _vm.handleRegisterLot
          }
        }, [_vm._v("\n          Registrar Lote\n        ")])], 1), _vm._v(" "), _c("lots-table", {
          attrs: {
            data: _vm.lots,
            "is-loading": _vm.isLoading
          },
          on: {
            "open-edit": _vm.openEditModal,
            "open-add-row": _vm.openAddRowModal
          }
        }), _vm._v(" "), _vm.meta.total > _vm.meta.perPage ? _c("b-pagination", {
          staticClass: "mt-4",
          attrs: {
            total: _vm.meta.total,
            current: _vm.meta.currentPage,
            "per-page": _vm.meta.perPage,
            "range-before": "2",
            "range-after": "2",
            size: "is-small",
            order: "is-centered"
          },
          on: {
            "update:current": function updateCurrent($event) {
              return _vm.$set(_vm.meta, "currentPage", $event);
            },
            change: _vm.handlePageChange
          }
        }) : _vm._e()], 1), _vm._v(" "), _vm.isEditModalActive ? _c("edit-lot-modal", {
          attrs: {
            lot: _vm.selectedLot,
            "is-modal-active": _vm.isEditModalActive
          },
          on: {
            onClose: function onClose($event) {
              _vm.isEditModalActive = false;
            },
            submit: function submit() {
              _vm.isEditModalActive = false;
              _vm.fetchLots();
            }
          }
        }) : _vm._e(), _vm._v(" "), _vm.isAddRowModalActive ? _c("add-section-row-modal", {
          attrs: {
            lot: _vm.selectedLot,
            "is-modal-active": _vm.isAddRowModalActive
          },
          on: {
            onClose: function onClose($event) {
              _vm.isAddRowModalActive = false;
            },
            created: function created() {
              _vm.isAddRowModalActive = false;
              _vm.handleAddedRow();
            }
          }
        }) : _vm._e()];
      },
      proxy: true
    }])
  });
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;